import React from 'react';

export const Quote = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--quote';
  color = color || '#0076CC';

  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M5.61488 17.0001H2.99988C2.46944 17.0001 1.96074 16.7894 1.58566 16.4143C1.21059 16.0393 0.999878 15.5306 0.999878 15.0001V3.00012C0.999878 2.46969 1.21059 1.96098 1.58566 1.58591C1.96074 1.21084 2.46944 1.00012 2.99988 1.00012H10.9999C11.5303 1.00012 12.039 1.21084 12.4141 1.58591C12.7892 1.96098 12.9999 2.46969 12.9999 3.00012V11.0001"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99988 15.9999L11.9999 17.9999L15.9999 13.9999"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 4.99988H9"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9H7"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Quote;
